import { useEffect } from "react";

function setMetaTag(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function usePageMeta(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ElitePlus` : "ElitePlus Solutions";
    document.title = fullTitle;

    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:title", fullTitle);
      setMetaTag("property", "og:description", description);
    }
  }, [title, description]);
}
